export const environment = {
  production: true,

 
siteURL: 'https://fci.gov.in/headquarter/',
  serviceURL: 'https://fci.gov.in/fci-storage/',
  apiUrl: 'https://fci.gov.in/admin/',
  tempUrl: 'https://fci.gov.in/admin/' + 'storage/temp/',
  CHATBOAT_API_URL: 'https://chatbot.fci.gov.in/',
  zoneURL: 'https://fci.gov.in/zone/',
  regionURL: 'https://fci.gov.in/region/',
  gisServiceURL: 'https://fci.gov.in/admin/',
  ifsUrl:"https://fci.gov.in/ifs/website/",
  hqURL: 'https://fci.gov.in/headquarter/', 
  homeURL: 'https://fci.gov.in/', 
  geoserverUrl: 'https://gis.fci.gov.in/geoserver/wms/',

  encryptIV: '26102021@qwI',
  apiHashingKey: '22CSMTOOL2022',
  invalidRequestMsg: 'Invalid Request',
  invalidResponseMsg: 'Invalid Response',
  workspace: 'FCI_STG',
  
  image_URL: 'assets/chatbot/images/',
  ZONE_ID: 32,
  ZONE_CODE: 'HQ',
  REGION_ID: 0,
  REGION_CODE: '',
};
